import { ApiProperty } from "@nestjs/swagger";
import { EmployeeDetailsDTO } from "./employee-details.dto";

export class EmployeeSkillMatrixDTO {

    @ApiProperty()
    employeeSkillMatrixId: number;

    @ApiProperty()
    machineWise: string;

    @ApiProperty()
    needleType: boolean;

    @ApiProperty()
    needleBarAdjustment: boolean;

    @ApiProperty()
    hookSetLooperTimings: boolean;

    @ApiProperty()
    stitchingAdjustment: boolean;

    @ApiProperty()
    uBTriming: boolean;

    @ApiProperty()
    feedTiming: boolean;

    @ApiProperty()
    programSetting: boolean;

    @ApiProperty()
    lubricationSystem: boolean;

    @ApiProperty()
    pullerAssembly: boolean;

    @ApiProperty()
    splitBarMechanism: boolean;

    @ApiProperty()
    gaugeSetReplacement: boolean;

    @ApiProperty()
    looperThreadTakeUpCamTiming: boolean;

    @ApiProperty()
    needleGaurdAdjustment: boolean;

    @ApiProperty()
    folderAttachementSettingBasic: boolean;

    @ApiProperty()
    snapDieFixing: boolean;

    @ApiProperty()
    safetyRequirements: boolean;

    @ApiProperty()
    preventiveMaintenance: boolean;

    @ApiProperty()
    OfSkillAquired: number;

    @ApiProperty()
    isActive: boolean;

    @ApiProperty()
    createdAt: Date;

    @ApiProperty()
    createdUser: string | null;

    @ApiProperty()
    updatedAt: Date;

    @ApiProperty()
    updatedUser: string | null;

    @ApiProperty()
    versionFlag: number;

    @ApiProperty()
    employeeId:number
    
}
